import {BaseForm, name} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useMemo, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const JobForm = forwardRef(({job, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  const entity = useMemo(() => {
    const subject = {...job};
    if (subject.company) {
      subject.company_id = subject.company.id;
      subject.company_name = subject.company.name;
    }
    if (subject.contact) {
      subject.contact_id = subject.contact.id;
      subject.contact_name = name(subject.contact);
    }
    if (subject.end_user) {
      subject.end_user_id = subject.end_user.id;
      subject.end_user_name = name(subject.end_user);
    }
    if (subject.installer) {
      subject.installer_id = subject.installer.id;
    }
    return subject;
  }, [job])

  return (
    <BaseForm
      ref={formRef}
      entity={entity}
      type="job"
      fieldsComponent={(props, onLoading) => <Fields onLoading={onLoading} {...props}/>}
      onSave={(update) => {
        const {latitude, longitude, company, contact, end_user, installer, ...data} = update;
        return services.job.saveJob(data);
      }}
      onSaved={onSaved}
    />
  );
});

export default JobForm;
